// ============================================================
// ConfirmModal
// ------------------------------------------------------------
// popup ยืนยัน (ส่วนใหญ่คือยืนยันการลบ) — ปุ่มยกเลิก/ยืนยันครึ่งจอ
// เดิม markup ชุดนี้ copy อยู่เกือบทุกหน้าที่มีปุ่มลบ
//
// ใช้:
//   <ConfirmModal
//     show={this.state.modal_delete}
//     title="ยืนยันการลบผู้ใช้งาน"
//     message="ท่านแน่ใจว่าต้องการลบข้อมูล ..."
//     onCancel={() => this.setState({ modal_delete: false })}
//     onConfirm={this.Delete}
//   />
// ============================================================

import React from "react";
import { Modal } from "react-bootstrap";

export default function ConfirmModal({
  show,
  title,
  message,
  onCancel,
  onConfirm,
  cancelText = "ยกเลิก",
  confirmText = "ยืนยัน",
  confirmClass = "btn-danger", // ปุ่มยืนยัน — ลบใช้แดง, ยืนยันทั่วไปส่ง "btn-primary"
  footerClassName = "w-100 d-flex", // บางหน้ามีระยะห่างต่างกันเล็กน้อย
  children, // เนื้อหาเพิ่มเติมใต้ข้อความ เช่นช่องกรอกหมายเหตุ
}) {
  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header>
        <Modal.Title>
          <b>{title}</b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message && (
          <div className="w-100 d-flex mb-3">
            <label>{message}</label>
          </div>
        )}
        {children}
        <div className={footerClassName}>
          <div className="w-50 p-1">
            <button className="btn btn-outline-primary w-100" onClick={onCancel}>
              {cancelText}
            </button>
          </div>
          <div className="w-50 p-1">
            <button className={`btn ${confirmClass} w-100`} onClick={onConfirm}>
              {confirmText}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
